export default __webpack_public_path__ + "static/media/surf.85e20324.webp";